import React from 'react'
import { Row, Typography, Card } from 'antd'
import { EmptyHeaderHero, SEO } from './components'

import TermsStyle from '../../styles/TermsConditions.module.css'

const { Title } = Typography

const TermsConditions = () => {
  return (
    <>
      <SEO
        title={"Terms & Conditions | CURE Auto Insurance"} 
        description={"Read the official Terms & Conditions for CURE auto insurance. Learn about your rights, responsibilities, and our policies for fair, transparent coverage."} 
        url={"/terms-conditions"}
      />
      <EmptyHeaderHero title="Terms & Conditions" />
      <div className={`${TermsStyle["terms-and-condition-screen"]}`}>
        <Row>
          <Card className={`${TermsStyle["terms-and-condition-card"]}`}>
            <article>
              <div className={`${TermsStyle["terms-and-condition-available-careers-desktop"]}`}>
                <a className={`${TermsStyle["link"]}`} href="/electronic-terms-conditions" style={{ height: '100%' }}>
                  <Title level={3} style={{ margin: 12, height: '100%' }}>
                    Electronic Terms & Conditions
                  </Title>
                </a>
              </div>
              <div>
                <h5>Introduction:</h5>
                <p>
                  CURE&apos;s website Terms and Conditions describe the rules for using this website. These Terms and
                  Conditions constitute a legally binding agreement between you, the person using this website, and
                  CURE. Please read them carefully. If you do not wish to be bound by these Terms and Conditions, please
                  discontinue using and accessing this site immediately.
                </p>
              </div>
              <p>
                By using this website, you agree to the most recent terms as well as the most recent version of our{' '}
                <a className={`${TermsStyle["terms-and-condition-hyperlinks"]}`} href="/privacy-notice" rel="noreferrer">
                  Privacy Notice
                </a>
                . We reserve the right to change these Terms and Conditions at any time, and such changes will be posted
                on this or a similar page of this website. Please check this page regularly for updates.
              </p>
            </article>

            <h5>Permitted Use:</h5>
            <p>
              This website is made available for your personal, lawful, non-commercial use in connection with seeking
              insurance. CURE prohibits use of this site by any competitor company or other non-consumer third party.
            </p>
            <p>
              Unless otherwise specified, this website is intended for your personal use only. You may not authorize
              others to use the website, and you are responsible for all use of the website by you and by those you
              allow to use, or provide access to, the website.
            </p>

            <h5>Links to Other Websites:</h5>
            <p>
              CURE does not verify nor make any warranty or representations about the content, accuracy, opinions
              expressed, warranties, products, services, intellectual property compliance or links of any Third-Party
              website. Such websites are maintained by the respective organizations and such third parties are solely
              responsible for the content of their own website. Inclusion of links to any third-party websites does not
              imply approval or endorsement of those websites or their content.
            </p>

            <h5>Disclaimer:</h5>
            <p>
              The information and descriptions contained in CURE&apos;s website are provided solely for informational
              purposes, and are not intended to be complete descriptions of all terms, exclusions, and conditions
              applicable to every insurance product or service offered by CURE. All content on this website is provided
              to you on an &quot;as is/as available&quot; basis. CURE hereby disclaims all warranties of any kind,
              either express or implied, statutory or otherwise including but not limited to the implied warranties of
              merchantability, fitness for a particular purpose and non-infringement.
            </p>
            <p>
              CURE does not warrant or make any representations regarding the accuracy, completeness or reliability of
              any of the content on this website. CURE makes no representations or warranties that use of the website
              will be uninterrupted or error-free, that defects will be corrected, or that this website or the server
              that makes it available are free of viruses or other harmful components. You are responsible for taking
              all precautions necessary to ensure that any content you may obtain from this website is free of viruses
              and any other potentially destructive components. You agree that you use this site at your own risk. If
              you are dissatisfied with this website or the content, your sole and exclusive remedy is to discontinue
              using the website.
            </p>

            <h5>Copyright and Trademarks:</h5>
            <p>
              All materials contained in this website are the property of CURE. All logos and other trademarks and
              service marks used on this site are owned by CURE and its affiliates, unless otherwise denoted. You may
              use materials obtained from this site for the purposes set forth in CURE&apos;s terms and conditions only.
              Any other use is prohibited.
            </p>

            <h5>Limitation of Liability:</h5>
            <p>
              CURE shall not be liable for any injury, loss, claim, or damage, nor any indirect, special, incidental or
              consequential or punitive damages of any kind, whether based in contract, tort, strict liability or
              otherwise, which arises out of the use of, or inability to use, this site or content found in this site,
              unless resulting from the gross negligence or intentional actions of CURE. Likewise, CURE shall not be
              liable for any injury, loss, claim, or damage, nor any indirect, special, incidental or consequential or
              punitive damages of any kind, whether based in contract, tort, strict liability or otherwise, that arises
              out of the unauthorized access to or alteration of your transmissions or data. This limitation applies
              even if CURE has been advised of the possibility of such damages.
            </p>

            <h5>Privacy:</h5>
            <p>
              CURE&apos;s{' '}
              <a className={`${TermsStyle["terms-and-condition-hyperlinks"]}`} href="/privacy-notice" rel="noreferrer">
                Privacy Notice
              </a>{' '}
              explains what information CURE may collect from you if you decide to provide such information, and how we
              will use and protect the information.
            </p>

            <h5>Alternative Log-In Methods/Biometric Authentication:</h5>
            <p>
              CURE's Mobile App may permit you to enable biometric authentication features supported by your device, such
              as facial, fingerprint, or other biometric recognition features (“Biometric Authentication”), for login and
              authentication purposes. Your use of Biometric Authentication is optional. You may enable or disable Biometric
              Authentication at any time through your device settings or within the Mobile App settings. CURE does not
              collect, receive, store, possess, access, or otherwise obtain your fingerprint, facial scan, face geometry,
              or other biometric identifiers or biometric information. Biometric credentials are stored locally on your device
              by your device manufacturer or operating system provider and are not transmitted to CURE. The Mobile App receives
              only a confirmation from your device indicating whether authentication was successful.
            </p>
            <p>
              By enabling Biometric Authentication, you acknowledge that any person whose biometric credentials are enrolled on
              your device may be able to access your account and information available through the Mobile App. CURE is not responsible
              for unauthorized access resulting from biometric credentials stored on your device or for the operation, availability,
              accuracy, or security of any biometric technology provided by your device manufacturer or operating system provider.
              You are responsible for maintaining the security of your device and controlling access to biometric credentials stored
              on the device.
            </p>

            <h5>Governing Law:</h5>
            <p>
              CURE&apos;s terms and conditions shall be governed by and interpreted according to the laws of the State
              of New Jersey.
            </p>

            <h5>Severability:</h5>
            <p>
              If any provision of this Agreement is determined to be invalid under any applicable statute or rule of
              law, it is to that extent to be deemed omitted, and the balance of the Agreement shall remain enforceable.
            </p>

            <h5>Indemnification:</h5>
            <p>
              You shall indemnify and hold CURE, its affiliates, successors in interest, officers, directors, employees
              and agents harmless from and against any claim, cause of action or demand, including without limitation
              reasonable legal fees, brought by or on your behalf in excess of the liability described herein or by
              third parties as a result of your use of the site.
            </p>

            <div className={`${TermsStyle["terms-and-condition-available-careers-mobile"]}`}>
              <a className={`${TermsStyle["link"]}`} href="/electronic-terms-conditions" style={{ height: '100%' }}>
                <Title level={3} style={{ margin: 12, height: '100%' }}>
                  Electronic Terms & Conditions
                </Title>
              </a>
            </div>
            <hr />
            <p className={`${TermsStyle["terms-and-condition-foot-note"]}`}>Version Date: March 31, 2022</p>
          </Card>
        </Row>
      </div>
    </>
  )
}

TermsConditions.propTypes = {}

export default TermsConditions
